import React, { forwardRef } from 'react';
import { Box, Typography } from '@mui/material';
import GeneralTile from './GeneralTile';
import ac_profile from '../../icons/my-ac-profile.svg';
import goals_icon from '../../icons/my-professional-goals.svg';
import social_boost from '../../icons/social-boost.svg';
import become_feature from '../../icons/become-feature.svg';

const ProfessionalBrandSection = forwardRef(
  (
    {
      isXS,
      isLargeScreen,
      accountDetails,
      openProfileDrawer,
      openProfessionalGoalsDrawer,
      goToSocialBoost,
    },
    ref
  ) => (
    <Box ref={ref} sx={{ mt: '28px' }}>
      <Typography
        id="professionalBrandTitle"
        sx={{
          fontWeight: '600',
          fontSize: { xxs: 24, xs: 32 },
          lineHeight: '130%',
          color: '#001030',
          display: 'flex',
        }}
      >
        <Typography
          component="span"
          sx={{
            fontWeight: '600',
            fontSize: { xxs: 24, xs: 32 },
            lineHeight: '130%',
            color: '#2B71F6',
          }}
        >
          {accountDetails.givenName}'s{' '}
        </Typography>
        &nbsp; Professional Brand
      </Typography>
      <Typography
        sx={{
          fontWeight: '400',
          fontSize: 16,
          color: '#2E3B56',
          mb: 2,
        }}
      >
        Use the tools below to optimize your professional brand and boost
        your visibility.
      </Typography>

      <Box
        sx={
          isXS || isLargeScreen
            ? {
                display: 'flex',
                flexDirection: isXS ? 'column' : 'row',
                justifyContent: 'space-between',
                columnGap: '20px',
                rowGap: '20px',
              }
            : {
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
                gap: '20px',
              }
        }
      >
        <GeneralTile
          ids={{
            tileID: 'profbrand-profile-tile',
            buttonID: 'profbrand-profile-cta',
          }}
          title="My AdvisoryCloud Profile"
          description="View, edit, and promote your AdvisoryCloud Profile to stand out as a valuable advisor. Set custom services and rates to attract paid advisory work."
          image={ac_profile}
          onClick={openProfileDrawer}
          buttonText="View Profile"
        />
        <GeneralTile
          ids={{
            tileID: 'profbrand-goals-tile',
            buttonID: 'profbrand-goals-cta',
          }}
          title="My Professional Goals"
          description="Add and track your long-term professional goals so AdvisoryCloud can recommend opportunities and help you reach new heights as an advisor."
          image={goals_icon}
          onClick={openProfessionalGoalsDrawer}
          buttonText="View Goals"
        />
        <GeneralTile
          ids={{
            tileID: 'profbrand-socialboost-tile',
            buttonID: 'profbrand-socialboost-cta',
          }}
          title="Social Boost"
          description="Let our team develop thought leadership content & strategy to promote your brand on social media and boost your professional SEO."
          image={social_boost}
          onClick={goToSocialBoost}
          buttonText="Learn More"
        />
        <GeneralTile
          ids={{
            tileID: 'profbrand-featured-tile',
            buttonID: 'getFeaturedTileCTA',
          }}
          title="Become a Featured Advisor"
          description="5x your visibility as an available advisor, stand out in boardrooms, get priority access to new opportunities, and let our team optimize your AdvisoryCloud Profile."
          image={become_feature}
          onClick={() => {}}
          buttonText="Get Featured"
        />
      </Box>
    </Box>
  )
);

export default ProfessionalBrandSection;
